import { css } from '@emotion/react';
import { MOBILE_BREAKPOINT } from '../../../../submission-details-view.constants';
import { dottedSeparatorStyle } from '../../patron-details.style';

const containerStyle = css`
  display: inline-flex;
  align-items: center;

  @container submission-details-view (max-width: ${MOBILE_BREAKPOINT}px) {
    overflow: hidden;
    flex-shrink: 2;
  }
`;

interface GetContainerStyleConfig {
  shouldShowSeparator: boolean;
}

export function getContainerStyle({ shouldShowSeparator }: GetContainerStyleConfig) {
  if (shouldShowSeparator) {
    return [containerStyle, dottedSeparatorStyle];
  }

  return containerStyle;
}
